import React, { useState, useEffect } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useGetUsersMeQuery, useGetProcurementProcessesByIdQuery, usePutProcurementProcessesByIdMutation, useGetDevelopmentsByIdQuery, Quotation, RequisitionItem } from '../../redux/vmsApi';
import PageWithHeader from '../common/PageWithHeader';
import { Formik } from 'formik';
import createRequisitionReviewModel, { RequisitionReviewType } from '../forms/models/createRequisitionReviewModel';
import LoadingCover from '../common/LoadingCover';
import ProcurementProcessDashboard from './components/ProcurementProcessDashboard';
import QuotationForm from './forms/OuotationForm';
import { toast } from 'react-toastify';
import RenderRequisitionDetails from './common/RenderRequisitionDetails';
import RenderRequisitionHeader from './common/renderRequisitionHeader';
import config from "../../config";
import { useParams } from "react-router-dom";

let updatedQuotationsAfterSelection: Quotation[];
const ViewRequisition: React.FC = () => {
  const params = useParams();
  const isInProcess: boolean = true;
  const { data: procurementProcess, isLoading, isError } = useGetProcurementProcessesByIdQuery({ id: params?.uuid ?? "" });
  const [updateProcurementProcess, { isSuccess, isLoading: isSubmitting }] = usePutProcurementProcessesByIdMutation();
  const { data: user } = useGetUsersMeQuery();
  const [showOverlay, setShowOverlay] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [redirectToDashboard, setRedirectToDashboard] = useState(false);
  const [showQuotationForm, setShowQuotationForm] = useState(false);

  const developmentId = procurementProcess?.requisition?.development.id;
  let procurementProcessPartial: any
  const { data: development } = useGetDevelopmentsByIdQuery(
    { id: developmentId! },
    { skip: !developmentId }
  );

  const [openDialog, setOpenDialog] = useState<string | null>(null);
  const [selectedSupplier, setSelectedSupplier] = useState<number | null>(null);

  const handleDialogOpen = (path: string) => setOpenDialog(`${config.CDN_URL}/procurement/${path}`);
  const handleDialogClose = () => setOpenDialog(null);
  useEffect(() => {
    setShowOverlay(isSubmitting || isSuccess);
    if (isSuccess) {
      setTimeout(() => {
        setShowOverlay(false);
        setShowSuccessMsg(true);
        setRedirectToDashboard(true);
      }, 3000);
    }
  }, [isSubmitting, isSuccess]);

  const handleSelectSupplier = async (index: number, quotation: any) => {
    const newSelection = selectedSupplier === index ? null : index;
    setSelectedSupplier(newSelection);

    if (newSelection !== null && procurementProcess?.currentTask === "CPOPicksSupplier") {
      const updatedQuotations = procurementProcess?.pcReview?.quotations?.map((q) => {

        if (q.supplier === quotation.supplier) {
          return { ...q, selected: true };
        }

        return { ...q, selected: false };
      });

      if (updatedQuotations) {
        updatedQuotationsAfterSelection = updatedQuotations;
      }
    }
  };


  const initialValues: RequisitionReviewType = {
    ...createRequisitionReviewModel.initialValues,
    quotations: [{
      supplier: { id: '', name: '' }, attachments: [], paymentTerms: '', remarks: '', selected: false, totalb4VAT: 0, totalVAT: 0, totalDiscount: 0, grandTotal: 0, currency: '', quotationNumber: '', deliveryLeadTime: 0, paymentUpfrontPercentage: undefined,
      quotationItems: [{
        unit: { id: '', name: '' },
        unitName: '',
        description: '',
        quantity: {
          quantityValue: 0,
          quantityUnit: ''
        },
        rate: 0,
        totalCostPerItem: 0,
        VAT: false,
        discountPerItem: 0
      }]
    }],
  };

  const handleSubmit = async (values: RequisitionReviewType) => {

    const sanitizeUpfront = (value: unknown) => {
      if (value === '' || value === null || value === undefined) return undefined;
      const parsed = Math.trunc(Number(value));
      return Number.isFinite(parsed) ? parsed : undefined;
    };

    const normalizedQuotations = values.quotations?.map((quotation, quotationIndex) => ({
      ...quotation,
      paymentUpfrontPercentage: sanitizeUpfront(quotation.paymentUpfrontPercentage),
      quotationItems: quotation.quotationItems?.map((quotationItem: any, itemIndex: number) => ({
        ...quotationItem,
        itemCode:
          quotationItem?.itemCode
          || procurementProcess?.pcReview?.quotations?.[quotationIndex]?.quotationItems?.[itemIndex]?.itemCode
          || '',
      })),
    }));

    const normalizedPcReviewQuotations = procurementProcess?.pcReview?.quotations?.map((quotation, quotationIndex) => ({
      ...quotation,
      paymentUpfrontPercentage: sanitizeUpfront(quotation.paymentUpfrontPercentage),
      quotationItems: quotation.quotationItems?.map((quotationItem: any, itemIndex: number) => ({
        ...quotationItem,
        itemCode:
          quotationItem?.itemCode
          || procurementProcess?.pcReview?.quotations?.[quotationIndex]?.quotationItems?.[itemIndex]?.itemCode
          || '',
      })),
    }));

    const reviewData: RequisitionReviewType = {
      comment: values.comment,
      approved: values.approved,
      user: {
        ...user,
        previousToken: '',
      },
      quotations: normalizedQuotations,
      dateReviewed: new Date(),
    };



    procurementProcessPartial = {
      initiatedDate: procurementProcess?.initiatedDate,
      lastActionedDate: new Date(),
      requestType: procurementProcess?.requestType || 'PROCUREMENT',
      priority: procurementProcess?.priority,
      status: procurementProcess?.status,
      splitPurchaseOrder: procurementProcess?.splitPurchaseOrder,
      requisitionDocument: procurementProcess?.requisitionDocument,
      purchaseOrderDocument: procurementProcess?.purchaseOrderDocument,
      siteManagerReview: {
        comment: procurementProcess?.siteManagerReview?.comment,
        approved: procurementProcess?.siteManagerReview?.approved,
        user: {
          ...procurementProcess?.siteManagerReview?.user,
          previousToken: '',
        },
        dateReviewed: procurementProcess?.siteManagerReview?.dateReviewed,
      },


      initiatedByUser: {
        ...procurementProcess?.initiatedByUser,
        previousToken: '',
      },
      requisition: {
        ...procurementProcess?.requisition,
        id: '',
        project: procurementProcess?.requisition.project,
        development: procurementProcess?.requisition.development,
        totalCost: procurementProcess?.requisition.totalCost,
        items: procurementProcess?.requisition?.items?.map((item: RequisitionItem) => ({
          ...item,
          itemCode: item.itemCode || '',
          quantity: {
            ...item.quantity,
            id: undefined,
          },
          unit: {
            id: item.unit?.id,
            name: item.unit?.name,
          },
          id: undefined,
        })),
      },
    };
    if (procurementProcess?.projectManagerReview) {
      procurementProcessPartial["projectManagerReview"] = {
        comment: procurementProcess?.projectManagerReview?.comment,
        approved: procurementProcess?.projectManagerReview?.approved,
        dateReviewed: procurementProcess?.projectManagerReview?.dateReviewed,
        user: {
          ...procurementProcess?.projectManagerReview?.user,
          previousToken: '',
        },
      };
    }

    if (procurementProcess?.cpoReview) {
      procurementProcessPartial["cpoReview"] = {
        comment: procurementProcess?.cpoReview?.comment,
        approved: procurementProcess?.cpoReview?.approved,
        dateReviewed: procurementProcess?.cpoReview?.dateReviewed,
        user: {
          ...procurementProcess?.cpoReview?.user,
          previousToken: '',
        },
      };
    }

    if (procurementProcess?.pmReview) {
      procurementProcessPartial["pmReview"] = {
        comment: procurementProcess?.pmReview?.comment,
        approved: procurementProcess?.pmReview?.approved,
        dateReviewed: procurementProcess?.pmReview?.dateReviewed,
        user: {
          ...procurementProcess?.pmReview?.user,
          previousToken: '',
        },
      };
    }
    if (procurementProcess?.proChairReview) {
      procurementProcessPartial["proChairReview"] = {
        comment: procurementProcess?.proChairReview?.comment,
        approved: procurementProcess?.proChairReview?.approved,
        dateReviewed: procurementProcess?.proChairReview?.dateReviewed,
        user: {
          ...procurementProcess?.proChairReview?.user,
          previousToken: '',
        },

      };
    }

    if (procurementProcess?.cfoReview) {
      procurementProcessPartial["cfoReview"] = {
        comment: procurementProcess?.cfoReview?.comment,
        approved: procurementProcess?.cfoReview?.approved,
        dateReviewed: procurementProcess?.cfoReview?.dateReviewed,
        user: {
          ...procurementProcess?.cfoReview?.user,
          previousToken: '',
        },
      };
    }

    if (procurementProcess?.pcReview) {
      procurementProcessPartial["pcReview"] = {
        comment: procurementProcess?.pcReview?.comment,
        approved: procurementProcess?.pcReview?.approved,
        dateReviewed: procurementProcess?.pcReview?.dateReviewed,
        user: {
          ...procurementProcess?.pcReview?.user,
          previousToken: '',
        },
        quotations: procurementProcess?.pcReview?.quotations?.map((quotation) => ({
          paymentTerms: quotation.paymentTerms,
          remarks: quotation.remarks,
          supplier: quotation.supplier,
          currency: quotation.currency,
          quotationNumber: quotation.quotationNumber,
          deliveryLeadTime: quotation.deliveryLeadTime,
          paymentUpfrontPercentage: (quotation.paymentUpfrontPercentage as unknown) === '' || quotation.paymentUpfrontPercentage == null ? undefined : Math.trunc(Number(quotation.paymentUpfrontPercentage)),
          termsAndConditionsTemplate: (quotation as any).termsAndConditionsTemplate,
          termsAndConditions: (quotation as any).termsAndConditions,
          attachments: quotation.attachments?.map((attachment) => ({
            name: attachment.name,
            url: attachment.url,
          })),
          quotationItems: quotation.quotationItems?.map((quotationItem: any, itemIndex: number) => ({
            ...quotationItem,
            itemCode:
              quotationItem?.itemCode
              || '',
          })),
          selected: quotation.selected
        })),
      };

    }


    if (!values.approved) {
      procurementProcessPartial.currentTask = "CorrectPurchaseRequisition";
      procurementProcessPartial.currentTaskOwner = "site-agent";
      procurementProcessPartial.previousTask = "SiteManagerReviewPurchaseRequisition";
      if (procurementProcess?.currentTask === "SiteManagerReviewPurchaseRequisition") {
        procurementProcessPartial["siteManagerReview"] = reviewData;
      } else if (procurementProcess?.currentTask === "ProjectManagerReviewPurchaseRequisition") {
        procurementProcessPartial["projectManagerReview"] = reviewData;
        procurementProcessPartial.previousTask = "ProjectManagerReviewPurchaseRequisition";
      } else if (procurementProcess?.currentTask === "PCToUploadQuotations") {
        procurementProcessPartial["pcReview"] = reviewData;
        procurementProcessPartial.previousTask = "PCToUploadQuotations";
        procurementProcessPartial.currentTaskOwner = "site-agent";
      }
      else if (procurementProcess?.currentTask === "PMToReviewProcurementApplication") {
        procurementProcessPartial["pmReview"] = reviewData;
        procurementProcessPartial.currentTask = "PCToUploadQuotations";
        procurementProcessPartial.currentTaskOwner = "procurement-clerk";
        procurementProcessPartial.previousTask = "PMToReviewProcurementApplication";
      }
      else if (procurementProcess?.currentTask === "CPOPicksSupplier") {
        procurementProcessPartial.currentTask = "PCToUploadQuotations";
        procurementProcessPartial.currentTaskOwner = "procurement-clerk";
        procurementProcessPartial.previousTask = "CPOPicksSupplier";
        procurementProcessPartial["cpoReview"] = reviewData;
        procurementProcessPartial.pcReview = {
          ...procurementProcess.pcReview,
          quotations: normalizedPcReviewQuotations,
        };
      }
      else if (procurementProcess?.currentTask === "ProChairReviewsSupplierChoice") {
        procurementProcessPartial.previousTask = "ProChairReviewsSupplierChoice";
        procurementProcessPartial.currentTask = "CPOPicksSupplier";
        procurementProcessPartial.currentTaskOwner = "cpo";
        procurementProcessPartial["proChairReview"] = reviewData;
        procurementProcessPartial.pcReview = {
          ...procurementProcess.pcReview,
          quotations: normalizedPcReviewQuotations,
        };
      }

      else if (procurementProcess?.currentTask === "CFOAllocateFunds") {
        return;
      }


      else if (procurementProcess?.currentTask === "COOToApprove") {
        procurementProcessPartial.previousTask = "COOToApprove";
        procurementProcessPartial.currentTask = "CFOAllocateFunds";
        procurementProcessPartial.currentTaskOwner = "cfo";
        procurementProcessPartial["cooReview"] = reviewData;
        procurementProcessPartial.pcReview = {
          ...procurementProcess.pcReview,
          quotations: normalizedPcReviewQuotations,
        };
        procurementProcessPartial.status = "Payment Requisitions Rejected"
      }

      else if (procurementProcess?.currentTask === "CEOToApprove") {
        procurementProcessPartial.previousTask = "CEOToApprove";
        procurementProcessPartial.currentTask = "CFOAllocateFunds";
        procurementProcessPartial.currentTaskOwner = "cfo";
        procurementProcessPartial["ceoReview"] = reviewData;
        procurementProcessPartial.pcReview = {
          ...procurementProcess.pcReview,
          quotations: normalizedPcReviewQuotations,
        };
        procurementProcessPartial.status = "Payment Requisitions Rejected"
      }

      else if (procurementProcess?.currentTask === "CFOAllocateFunds") {
        return;
      }
    }

    if (values.approved && procurementProcess?.currentTask === "SiteManagerReviewPurchaseRequisition") {
      procurementProcessPartial["siteManagerReview"] = reviewData;
      procurementProcessPartial.currentTask = "ProjectManagerReviewPurchaseRequisition";
      procurementProcessPartial.currentTaskOwner = "project-manager";
      procurementProcessPartial.previousTask = "SiteManagerReviewPurchaseRequisition";
      procurementProcessPartial["status"] = "New Requisition"
    } else if (values.approved && procurementProcess?.currentTask === "ProjectManagerReviewPurchaseRequisition") {

      procurementProcessPartial.currentTask = "PCToUploadQuotations";
      procurementProcessPartial.currentTaskOwner = "procurement-clerk";
      procurementProcessPartial.previousTask = "ProjectManagerReviewPurchaseRequisition";
      procurementProcessPartial["projectManagerReview"] = reviewData;
      procurementProcessPartial.requisition.approved = true;
    }



    if (values.approved && procurementProcess?.currentTask === "PCToUploadQuotations") {
      procurementProcessPartial["status"] = "New Purchase Order"
      procurementProcessPartial.currentTask = "CPOPicksSupplier";
      procurementProcessPartial.currentTaskOwner = "cpo";
      procurementProcessPartial.previousTask = "PMToReviewProcurementApplication";
      procurementProcessPartial["pcReview"] = reviewData;

    }

    if (values.approved && procurementProcess?.currentTask === "CPOPicksSupplier") {

      procurementProcessPartial.currentTask = "ProChairReviewsSupplierChoice";
      procurementProcessPartial.currentTaskOwner = "pro-chair";
      procurementProcessPartial.previousTask = "CPOPicksSupplier";
      if (updatedQuotationsAfterSelection) {
        procurementProcessPartial.pcReview.quotations = updatedQuotationsAfterSelection;
      }

      if (updatedQuotationsAfterSelection) {
        procurementProcessPartial.pcReview.quotations = updatedQuotationsAfterSelection.map(quotation => ({
          ...quotation,
          selected: !!quotation.selected
        }));
      }



      const q = procurementProcessPartial.pcReview.quotations.find(
        (q: { selected: boolean }) => q.selected === true
      );
      const hasZeroGrandTotal = typeof q?.grandTotal !== 'number' || q.grandTotal === 0;
      if (!q.selected) {
        alert('Supplier not picked');
        return;
      }
      if (q.selected && hasZeroGrandTotal) {
        alert('Quotations not uploaded properly');
        return;
      }
      procurementProcessPartial["cpoReview"] = reviewData;


    }

    if (values.approved && procurementProcess?.currentTask === "ProChairReviewsSupplierChoice") {
      // procurementProcessPartial.currentTask = "PMToIssuePurchaseOrder";
      procurementProcessPartial.currentTask = "CFOAllocateFunds";
      procurementProcessPartial.currentTaskOwner = "cfo";
      procurementProcessPartial.previousTask = "ProChairReviewsSupplierChoice"
      procurementProcessPartial["proChairReview"] = reviewData;
      procurementProcessPartial.pcReview = {
        ...procurementProcess.pcReview,
        quotations: normalizedPcReviewQuotations,
      };
      procurementProcessPartial["status"] = "Payment Requisition"
    }

    if (values.approved && procurementProcess?.status === "COO To Approve Payment Requisitions" && !(procurementProcess?.currentTask === "COOToApprove" || procurementProcess?.currentTask === "CEOToApprove")) {
      procurementProcessPartial.currentTask = "COOToApprove";
      procurementProcessPartial.currentTaskOwner = "coo";
      procurementProcessPartial.previousTask = "CFOAllocateFunds";
      procurementProcessPartial["cfoReview"] = reviewData;
      procurementProcessPartial.pcReview = {
        ...procurementProcess.pcReview,
        quotations: normalizedPcReviewQuotations,
      };
    }

    if (values.approved && procurementProcess?.status === "CPO To Prioritize Payment Requisitions" && !(procurementProcess?.currentTask === "COOToApprove" || procurementProcess?.currentTask === "CEOToApprove")) {
      procurementProcessPartial.currentTask = "CPOToPrioritizePayments";
      procurementProcessPartial.currentTaskOwner = "cpo";
      procurementProcessPartial.previousTask = "CFOAllocateFunds";
      procurementProcessPartial["cfoReview"] = reviewData;
      procurementProcessPartial.pcReview = {
        ...procurementProcess.pcReview,
        quotations: normalizedPcReviewQuotations,
      };
    }

    if (values.approved && procurementProcess?.status === "CEO To Approve Payment Requisitions" && !(procurementProcess?.currentTask === "COOToApprove" || procurementProcess?.currentTask === "CEOToApprove")) {
      procurementProcessPartial.currentTask = "CEOToApprove";
      procurementProcessPartial.currentTaskOwner = "ceo";
      procurementProcessPartial.previousTask = "CFOAllocateFunds";
      procurementProcessPartial["cfoReview"] = reviewData;
      procurementProcessPartial.pcReview = {
        ...procurementProcess.pcReview,
        quotations: normalizedPcReviewQuotations,
      };
    }

    if (values.approved && (procurementProcess?.currentTask === "COOToApprove" || procurementProcess?.currentTask === "CEOToApprove")) { 
      procurementProcessPartial.status = "CPO To Prioritize Payment Requisitions"
      if (procurementProcess.currentTask === "COOToApprove") {
        procurementProcessPartial.previousTask = "COOToApprove";
        procurementProcessPartial["cooReview"] = reviewData;
      } else if (procurementProcess.currentTask === "CEOToApprove") {
        procurementProcessPartial.previousTask = "CEOToApprove";
        procurementProcessPartial["ceoReview"] = reviewData;
      }

      procurementProcessPartial.currentTask = "CPOToPrioritizePayments";
      procurementProcessPartial.currentTaskOwner = "cpo";

      procurementProcessPartial.pcReview = {
        ...procurementProcess.pcReview,
        quotations: normalizedPcReviewQuotations,
      };

    }
    setShowOverlay(true);
    try {
      const result = await updateProcurementProcess({
        id: params?.uuid ?? "",
        procurementProcessPartial
      }).unwrap();
      setShowOverlay(false);
      if (result) {
        toast.success('Procurement process updated successfully.');
      }
    } catch (error) {
      setShowOverlay(false);
      console.error("Completing Task Failed:", error);
      toast.error('Failed to update procurement process.');
    }
  };


  if (redirectToDashboard) {
    return <ProcurementProcessDashboard />;
  }

  if (isLoading || !procurementProcess) {
    return (
      <LoadingCover />
    );
  }

  if (procurementProcess?.requisition && (!isLoading || !isError)) {
    return (
      <React.Fragment>
        <PageWithHeader>
          <RenderRequisitionHeader development={development || 'Development'} />
          {development && (
            <RenderRequisitionDetails
              procurementProcess={procurementProcess}
              development={development}
              selectedSupplier={selectedSupplier}
              openDialog={openDialog}
              handleDialogOpen={handleDialogOpen}
              handleDialogClose={handleDialogClose}
              handleSelectSupplier={handleSelectSupplier}
              showQuotationForm={showQuotationForm}
              setShowQuotationForm={setShowQuotationForm}
              isInProcess={isInProcess}
            />
          )}

          {procurementProcess?.currentTask === "PCToUploadQuotations" && (
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setShowQuotationForm(!showQuotationForm)}
              >
                {showQuotationForm ? "Request Requisition Amendments" : "Proceed with Quotations Upload"}
              </Button>
            </Stack>
          )}
          <br></br>


          <br></br>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue, values }) => (
              <QuotationForm
                procurementProcess={procurementProcess}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                values={values}
                showQuotationForm={showQuotationForm}
                setShowQuotationForm={setShowQuotationForm}
              />
            )}
          </Formik>
        </PageWithHeader>

        {showOverlay && <LoadingCover isSuccess={isSuccess} />}
        {showSuccessMsg && (
          <Stack>
            <Typography>Thank you, your response has been received</Typography>
            <Button onClick={() => window.location.reload()} variant="text" sx={{ maxWidth: '200px' }}>Create Another</Button>
          </Stack>
        )}
      </React.Fragment>
    );
  } else return <></>;

};

export default ViewRequisition;
